import { Box, ButtonV2, FormControl } from '@withjoy/joykit';
import { Search } from '@withjoy/joykit/icons';
import React from 'react';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { useSearchFormConfig } from '../LocationDatesOccupantsSearchBar';

export const SubmitButton = () => {
  const { tq } = useTranslation('accommodationsConsole');
  const { isOpenedFormView, isCompactVersion } = useSearchFormConfig();

  if (isOpenedFormView) {
    return (
      <FormControl
        padding={5}
        background="white"
        bottom={0}
        position="sticky"
        width="100%"
        borderTop="solid 1px"
        borderColor="mono3"
        zIndex="sticky"
      >
        <ButtonV2
          type="submit"
          width="100%"
          variant="solid"
          shape="rounded"
          intent="newPrimary"
          borderRadius={pxToRem(12)}
        >
          {tq`Search`}
        </ButtonV2>
      </FormControl>
    );
  }

  return (
    <FormControl width={isCompactVersion ? '100%' : { _: '100%', md: 'auto' }}>
      <ButtonV2
        type="submit"
        variant="solid"
        intent={'newPrimary'}
        shape={'rounded'}
        width={isCompactVersion ? '100%' : { _: '100%', md: pxToRem(48) }}
        height={pxToRem(40)}
      >
        <Box
          display={isCompactVersion ? 'none' : { _: 'none', md: 'flex' }}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Search />
        </Box>
        <Box display={isCompactVersion ? 'block' : { _: 'block', md: 'none' }}>{tq`Search`}</Box>
      </ButtonV2>
    </FormControl>
  );
};
